import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'app-mobile-configuration',
  templateUrl: './mobile-configuration.component.html',
  styleUrls: ['./mobile-configuration.component.css']
})
export class MobileConfigurationComponent implements OnInit {
  
  @ViewChild('modalShow') modalShow;
  @ViewChild('modalHide') modalHide;

  public userData;

  public mobileObj=[];
  public filteredData = [];
  public tableData = [];
/*   {
    name:"test1",
    mobile:9814312341,
    orgID:"60866279d774d4408635033b",
    mobileID:"1234",
  },
  {
    name:"test2",
    mobile:234523423,
    orgID:"60866279d774d4408635033b",
    mobileID:"112341",
  } */
  public editMobileObj={};
  public mobileForm:FormGroup;
  public searchForm:FormGroup;
  public name=this.fb.control('',[Validators.required]);
  public mobile=this.fb.control('',[Validators.required,Validators.pattern('{0-9}{10}')]);
  public modalTitle;
  public modalType;
  public mobileID;
  public filterEnable:boolean=false;
  public enableTable:boolean = false;
  
  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder) { 
      this.userData = this.storage.get('userInfo')
  }

  ngOnInit(): void {
    this.addMobileForm();
    this.searchFormLoad();
    this.getMobileData();
    
  }
  
  addMobileForm(){
    this.mobileForm=this.fb.group({
      name:this.fb.control('',[Validators.required]),
      mobileNo:this.fb.control('',[Validators.required,Validators.pattern('[0-9]{10}')]),
    });
  }
  searchFormLoad(){
    this.searchForm=this.fb.group({
     name:[''],
     mobileNo:[''],
    })
  }
  fieldChange(){
    this.filteredData = [ ...this.mobileObj];
    this.tableData = [ ...this.mobileObj];
    console.log(this.searchForm.value);
    Object.entries(this.searchForm.value).forEach(([key, value]) => {
      if (value)  this.filterNotification(key,value);  });
  }

  filterNotification(key,value){
      if (key=='name'){
        this.filteredData = this.filteredData.filter((e)=>{
          let userName = e[key].toLowerCase();
          if(userName.search(value.toLowerCase()) !=-1 )
            return e;   
          });
      }
      if (key=='mobileNo'){
        this.filteredData = this.filteredData.filter((e)=>{
          if(e[key].search(String(value)) != -1) return e;  });
      }
    this.tableData = [ ...this.filteredData];
  }
  resetFilter(){
    this.tableData = [ ...this.mobileObj];
  }
  filterOption(field,event){
    console.log(field);
    console.log(event.target.value);
  }
  mobileModal(modalType){
    if(modalType=='add'){
      this.modalTitle='Add Mobile';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }
    if(modalType=='edit'){
      this.modalTitle='Edit Mobile';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }
  }
  addFormValues(){
    console.log(this.mobileForm.value);
    if(this.mobileForm.valid){
      this.createMobile();
      this.modalClose();
    }
  }
  editFormValues(){
    if(this.mobileForm.valid){
      let updateObj={};
      let key=Object.keys(this.mobileForm.value);
      key.filter((item)=>{
        if(this.editMobileObj[item]!=this.mobileForm.value[item]){
          updateObj[item]=this.mobileForm.value[item];
        }
      })

      if (Object.keys(updateObj).length>0) this.updateMobile(updateObj);

      this.modalClose();
    }
  }
  modalClose(){
    this.modalHide.nativeElement.click();
    this.modalTitle='';
    this.modalType='';
    this.mobileID=undefined;
    this.mobileForm.reset();
    console.log(this.mobileForm);
  }

  resetForms(formDirective:FormGroupDirective){
    formDirective.resetForm();
  }

  editMobileData(element){
    this.mobileID=element.notificationID;
    this.patchMobileValue(element)
    this.mobileModal('edit');
  }
  patchMobileValue(element){
    let obj={name:element.name,mobileNo:element.mobileNo};
    this.mobileForm.patchValue(obj);
    this.editMobileObj=obj;
  }

/* get mobile data*/
  getMobileData() {
    const obj = {
      orgID: this.userData.orgID,
      type:"list",
      notification:"mobile",
    };
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.mobileObj = res.data;
        this.tableData = [ ...this.mobileObj];
        this.enableTable = true;
      }
    }).catch((err) => {
      console.log(err);
    });
    console.log(this.mobileObj);
  }
/* patch mobile values */
  setMobileValue(){
    console.log(this.mobileObj);
  }

  onSubmit(){
    console.log(this.mobileForm.value);
  }
  updateMobile(updateValues){
    let obj={
      orgID:this.userData.orgID,
      type:"update",
      notification:"mobile",
      notificationID:this.mobileID,
      ...updateValues
    }
    let uniqueValue = false;
    if (obj['mobileNo']) {
      obj['mobileNo']=String(obj['mobileNo']);
      uniqueValue = this.checkUniqueNo(obj['mobileNo']);
    }
    if(uniqueValue) this.uniqueNumberAlert();
    else{
      this.api.transportManagerNotificationConfig(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.getMobileData();
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  createMobile(){
    let obj={
      orgID:this.userData.orgID,
      type:"create",
      notification:"mobile",
      ...this.mobileForm.value,
    };
    obj['mobileNo']=String(obj['mobileNo']);
    let uniqueValue = this.checkUniqueNo(obj['mobileNo']);
    if(uniqueValue) this.uniqueNumberAlert();
    else{
      console.log(obj);
      this.api.transportManagerNotificationConfig(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.getMobileData();
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  checkUniqueNo(mobile){
    let findValue = false;
    let sameMobile = this.mobileObj.find((mob)=>mob.mobileNo == mobile);
    if (sameMobile) findValue = true;
    return findValue
  }
  uniqueNumberAlert(){
    console.log(this.mobileForm.value);
    this.swal.swalFunction('error', 'Failure', 'Mobile No already existed !', 3000);
    this.modalClose();
  }
  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteMobile(id);
        /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  deleteMobile(id){
    let obj={
      orgID: this.userData.orgID,
      type:"delete",
      notification:"mobile",
      notificationID:id,
    }
    console.log(obj);
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getMobileData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
